import { ProductConditionOption } from "./product-condition-option";

/**
 * Readonly on purpose: the condition components are OnPush and read these
 * through signal inputs, so the view only updates when the object is replaced.
 * Parents already rebuild immutably ({ ...condition, checked: true }); these
 * modifiers turn a future in-place mutation into a build failure rather than a
 * silently stale UI.
 */
export interface ProductCondition {
  readonly id: number;
  readonly product_id: number;
  readonly text: string;
  readonly required: boolean;
  readonly type: string | null;
  readonly product_condition_options: ProductConditionOption[];
  readonly updated_at: Date | null;

  // artificial properties
  // TODO: Make this part of the UI model!!!
  readonly selectedProductConditionOption?: ProductConditionOption | null;
  readonly checked?: boolean;
}


export const isDropdown = (condition: ProductCondition): boolean => {
  return condition.product_condition_options.length > 0;
}

export const isCheckbox = (condition: ProductCondition): boolean => {
  return !isDropdown(condition);
}

export const hasSelection = (condition: ProductCondition): boolean => {
  if (isDropdown(condition)) {
    return !!condition.selectedProductConditionOption;
  } 
  
  return true;
}

export const getResponse = (condition: ProductCondition): string | boolean | null => {
  if (isCheckbox(condition)) {
    return condition.checked ?? false;
  } else if (hasSelection(condition)) {
    return condition.selectedProductConditionOption?.value ?? null;
  }

  return null;
}

export const isValid = (condition: ProductCondition): boolean => {
  if (condition.required) {
    return hasSelection(condition);
  }

  return true;
}
